export default __webpack_public_path__ + "static/media/transparent-logo.f947166e.png";